import { Suspense, useEffect } from 'react';
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer, setOpen } from '../../redux/reducer/drawerSlice';
import PageLoader from '../loader/LoaderText';
import PolicyDrawerComponent from './policyDocument';
import DocumentDrawerComponent from './documents';
import ProjectMilestoneForm from './project-milestone';
import RolesView from './roles';
import TriPartyMouPage from './tri-party-mou';
import CollaborationAgreementPage from './collaboration-agreement';

const CommonDrawerComponent = () => {
    const dispatch = useDispatch();
    const drawer = useSelector((state: any) => state.drawer);
    const open = useSelector((state: any) => state.drawer.open);

    const drawerWidthMapping: Record<string, number> = {
        xl: 1600,
        lg: 1200,
        md: 1000,
        sm: 800,
    };

    const getDrawerWidth = () => {
        if (drawer.isFullScreen) return "100%";
        if (drawer.drawerWidth) {
            return drawerWidthMapping[drawer.drawerWidth];
        }
        return 1400;
    };

    const handleClose = (newOpen: boolean) => () => {
        if (newOpen) {
            dispatch(setOpen(true));

            return;
        }
        if (!newOpen) {
            dispatch(closeDrawer());
            dispatch(setOpen(false));

        }
    };

    useEffect(() => {
        drawer?.tab !== 6 && drawer?.name && dispatch(setOpen(true))
    }, [drawer, dispatch])

    return (
        <Drawer anchor='right' open={open} PaperProps={{
            sx: { maxWidth: getDrawerWidth(), width: '100%', overflowY: "unset" },
        }}>
            <Box sx={{ bgcolor: 'primary.main', height: 59, display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, boxShadow: 7, position: 'sticky', top: 0, zIndex: 2, padding: 2 }}>
                <Typography variant='h3' color='primary.contrastText' sx={{ maxWidth: '80%' }}>{drawer.title}</Typography>
                <Button sx={{ zIndex: 1300 }} size='small' variant='contained' color='error' onClick={handleClose(false)} endIcon={<CloseIcon />}>Close</Button>
            </Box>
            <Box sx={{ overflowY: 'auto', height: 'calc(100vh - 59px)' }}>
                <Suspense fallback={<PageLoader />}>
                    <PolicyDrawerComponent handleClose={handleClose} />
                    <DocumentDrawerComponent handleClose={handleClose} />
                    <DocumentDrawerComponent handleClose={handleClose} />
                    <ProjectMilestoneForm />
                    <CollaborationAgreementPage />
                    <TriPartyMouPage />
                    <RolesView />
                </Suspense>
            </Box>
        </Drawer>
    )
}

export default CommonDrawerComponent;